import React, { FC, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { CourseCard } from 'src/common/components/CourseCard';
import { ZoomCard } from 'src/common/components/ZoomCard';
import { media } from 'src/config/breakpoints';
import { UserCoursesCard } from 'src/user/courses/components/UserCoursesCard';
import { UserCoursesCards } from 'src/user/courses/components/UserCoursesCards';
import { EventUserListItem, mapToCourseExcerpt } from 'src/common/models/event';

const StyledZoomCard = styled(ZoomCard)`
  ${media.w.min.px576(css`
    display: none;
  `)};
`;

const ZoomUserCoursesCard = styled(UserCoursesCard)`
  ${media.w.max.px576(css`
    display: none;
  `)};
`;

export interface UserCoursesUpcomingContentProps {
  items: EventUserListItem[];
}

export const UserCoursesUpcomingContent: FC<UserCoursesUpcomingContentProps> = ({ items }) => {
  const courseExcerpts = useMemo(
    () =>
      items.map(mapToCourseExcerpt).map((a) => (
        <UserCoursesCard key={a.id}>
          <CourseCard largeMobileImage courseExcerpt={a} />
        </UserCoursesCard>
      )),
    [items],
  );

  return (
    <div>
      <UserCoursesCards>
        {courseExcerpts}

        <ZoomUserCoursesCard>
          <ZoomCard />
        </ZoomUserCoursesCard>
      </UserCoursesCards>

      <StyledZoomCard />
    </div>
  );
};
